// 点击按钮，在当前按钮所在画布中创建二维码并显示
export default {
  methods: {
    specialClickShowQrCodePlugin() {
      // let qrCode = require("../../../../../assets/images/qrCode.png")
      // const dom = $(`#container_${this.myid.container_id} #rect_${this.myid.rect_id} .btn-inner`)[0]
      // if (dom) {
      //   dom.addEventListener(
      //     "click",
      //     event => {
      //       const specialClickShowQrCodePluginMask =
      //         "<div class='specialClickShowQrCodePluginMask' style='width:100%;height:100%;background: rgba(0, 0, 0, 0.4);z-index: 99;}'></div>"
      //       const layer =
      //         "<div class='specialClickShowQrCodePluginQrCodeDialog' style='z-index: 999;text-align: center;position: absolute;top: calc(50% - 2.9333rem);left: calc(50% - 2.2667rem);'><div style='background: #FFFFFF;padding: .4267rem .9333rem; border-radius: .2667rem;'><img style='width: 2.6667rem;height: 2.6667rem;' src='" +
      //         qrCode +
      //         "'><span style='display: block;font-size: .32rem;line-height: .48rem;text-align: center;color: #404040;margin-top: .2133rem;'>立即扫码下载客户端</span></div><span class='specialClickShowQrCodePluginDeleteBtn icon-portal-close-small1' style='background: #ffffff;font-size:1.0667rem; margin-top: .5867rem;display: inline-block;border-radius:50%;'></span></div>"
      //       $(`#container_${this.myid.container_id}`).append(specialClickShowQrCodePluginMask)
      //       $(`#container_${this.myid.container_id}`).append(layer)
      //       $(".specialClickShowQrCodePluginDeleteBtn")[0].addEventListener(
      //         "click",
      //         () => {
      //           $(".specialClickShowQrCodePluginQrCodeDialog").remove()
      //           $(".specialClickShowQrCodePluginMask").remove()
      //         },
      //         false
      //       )
      //     },
      //     false
      //   )
      // }
    }
  }
}
